// extracted by mini-css-extract-plugin
export default {"wrap":"BookDemoCTA_wrap__KW281","label":"BookDemoCTA_label__7OQi2","btn":"BookDemoCTA_btn__88KsV"};